const LONG_ARTICLE_THRESHOLD = 6000;
const TARGET_PAGE_WEIGHT = 4500;

function serializeNode(node) {
  if (node.outerHTML !== undefined) return node.outerHTML;
  const holder = document.createElement("div");
  holder.appendChild(node.cloneNode(true));
  return holder.innerHTML;
}

function blockWeight(node) {
  const textWeight = (node.textContent || "").trim().length;
  const mediaWeight = node.querySelectorAll?.("img, video, audio").length * 1200 || 0;
  const embedWeight = node.querySelectorAll?.("iframe").length * 1800 || 0;
  return Math.max(1, textWeight + mediaWeight + embedWeight);
}

function isHeading(node) {
  return /^H[1-6]$/.test(node.nodeName);
}

export function paginateArticleHtml(html) {
  if (!html || typeof DOMParser === "undefined") return [html || ""];
  const documentNode = new DOMParser().parseFromString(`<div id="article-reader-root">${html}</div>`, "text/html");
  const root = documentNode.getElementById("article-reader-root");
  if (!root) return [html];

  const blocks = Array.from(root.childNodes).filter(
    (node) => node.nodeType !== Node.TEXT_NODE || node.textContent.trim(),
  );
  const totalWeight = blocks.reduce((sum, node) => sum + blockWeight(node), 0);
  if (totalWeight < LONG_ARTICLE_THRESHOLD || blocks.length < 2) return [html];

  const groups = [];
  for (let index = 0; index < blocks.length; index += 1) {
    const nodes = [blocks[index]];
    if (isHeading(blocks[index]) && blocks[index + 1] && !isHeading(blocks[index + 1])) {
      nodes.push(blocks[index + 1]);
      index += 1;
    }
    groups.push({
      html: nodes.map(serializeNode).join(""),
      weight: nodes.reduce((sum, node) => sum + blockWeight(node), 0),
    });
  }

  const pages = [];
  let current = [];
  let currentWeight = 0;
  groups.forEach((group) => {
    if (current.length && currentWeight + group.weight > TARGET_PAGE_WEIGHT) {
      pages.push(current.join(""));
      current = [];
      currentWeight = 0;
    }
    current.push(group.html);
    currentWeight += group.weight;
  });
  if (current.length) pages.push(current.join(""));
  return pages.length > 1 ? pages : [html];
}

export function prepareArticleContent(html, origin = window.location.origin) {
  if (!html || typeof DOMParser === "undefined") return { html: html || "", pdfs: [] };
  const documentNode = new DOMParser().parseFromString(`<div id="article-reader-root">${html}</div>`, "text/html");
  const root = documentNode.getElementById("article-reader-root");
  if (!root) return { html, pdfs: [] };

  const pdfs = [];
  root.querySelectorAll("a[href]").forEach((anchor) => {
    try {
      const url = new URL(anchor.getAttribute("href"), origin);
      const isMediaPdf = url.origin === origin
        && url.pathname.startsWith("/api/media/")
        && url.pathname.toLowerCase().endsWith(".pdf");
      if (!isMediaPdf) return;
      pdfs.push({
        url: `${url.pathname}${url.search}`,
        label: anchor.textContent.trim() || "PDF document",
      });
      const parent = anchor.parentElement;
      if (parent?.nodeName === "P" && parent.textContent.trim() === anchor.textContent.trim()) {
        parent.remove();
      } else {
        anchor.remove();
      }
    } catch {
      // Leave malformed links in the existing article body.
    }
  });

  return { html: root.innerHTML, pdfs };
}
